import { experimental_extendTheme as extendTheme } from "@mui/material/styles";

import {
  shadows,
  typography,
  components,
  colorSchemes,
  customShadows,
} from "./core";

import type { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export function createTheme(mode: "light" | "dark"): Theme {
  const initialTheme = {
    colorSchemes: {
      light: colorSchemes.light,
      dark: colorSchemes.dark,
    },
    defaultColorScheme: mode, // Add this line
    shadows: shadows(),
    customShadows: customShadows(),
    shape: { borderRadius: 4 },
    components,
    typography,
    cssVarPrefix: "",
    shouldSkipGeneratingVar,
  };

  console.debug("Creating theme with mode:", mode);
  console.debug("Color scheme:", colorSchemes[mode]);

  const theme = extendTheme(initialTheme);
  return theme;
}

// ----------------------------------------------------------------------

function shouldSkipGeneratingVar(
  keys: string[],
  _value: string | number
): boolean {
  const skipGlobalKeys = [
    "mixins",
    "overlays",
    "direction",
    "typography",
    "breakpoints",
    "transitions",
    "cssVarPrefix",
    "unstable_sxConfig",
  ];

  const skipPaletteKeys: { [key: string]: string[] } = {
    global: ["tonalOffset", "dividerChannel", "contrastThreshold"],
    grey: ["A100", "A200", "A400", "A700"],
    text: ["icon"],
  };

  const isPaletteKey = keys[0] === "palette";

  if (isPaletteKey) {
    const paletteType = keys[1];
    const skipKeys = skipPaletteKeys[paletteType] || skipPaletteKeys.global;

    return keys.some((key) => skipKeys?.includes(key));
  }

  return keys.some((key) => skipGlobalKeys?.includes(key));
}

export default createTheme;
